import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
// import VueMeta from "vue-meta";

Vue.use(Vuetify);
// Vue.use(VueMeta, {
//   // optional pluginOptions
//   refreshOnceOnNavigation: true,
// });

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#3f51b5",
        secondary: "#b0bec5",
        accent: "#8c9eff",
        error: "#FF5252",
        info: "#FFEB3B",
      },
    },
  },
});

